"use strict";
import { combineReducers } from "redux";
import { uniswapBehaviorHistoryReducer } from "features/behaviorHistory/slice";
import { favoritesReducer } from "features/favorites/slice";
import { fiatOnRampAggregatorApi } from "features/fiatOnRamp/api";
import { notificationReducer } from "features/notifications/slice";
import { portfolioReducer } from "features/portfolio/slice/slice";
import { searchHistoryReducer } from "features/search/searchHistorySlice";
import { userSettingsReducer } from "features/settings/slice";
import { timingReducer } from "features/timing/slice";
import { tokensReducer } from "features/tokens/slice/slice";
import { transactionSettingsReducer } from "features/transactions/settings/slice";
import { transactionReducer } from "features/transactions/slice";
import { swapSettingsReducer } from "features/transactions/swap/contexts/slice";
import { visibilityReducer } from "features/visibility/slice";
export const uniswapReducers = {
  [fiatOnRampAggregatorApi.reducerPath]: fiatOnRampAggregatorApi.reducer,
  swapSettings: swapSettingsReducer,
  favorites: favoritesReducer,
  notifications: notificationReducer,
  portfolio: portfolioReducer,
  searchHistory: searchHistoryReducer,
  timing: timingReducer,
  tokens: tokensReducer,
  transactions: transactionReducer,
  transactionSettings: transactionSettingsReducer,
  uniswapBehaviorHistory: uniswapBehaviorHistoryReducer,
  userSettings: userSettingsReducer,
  visibility: visibilityReducer
};
export const uniswapReducer = combineReducers(uniswapReducers);
export const uniswapPersistedStateList = [
  "favorites",
  "portfolio",
  "searchHistory",
  "tokens",
  "transactions",
  "uniswapBehaviorHistory",
  "userSettings",
  "visibility"
];
